module.exports = __webpack_public_path__ + "img/6.00d1e932.png";